import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ContainerModalSetFilter, TextFieldStyle } from './ModalFilter.style'
import dayjs from 'dayjs'

const ModalFilterDateSearch = ({ onModelChange, name }) => {
  const [date, setDate] = useState({ [name]: '' })

  const valueChanged = event => {
    let { name, value } = event.target
    value = value !== '' ? dayjs(value).format('YYYY-MM-DD') : ''
    setDate({ [name]: value })
    onModelChange({ [name]: value })
  }

  return (
    <ContainerModalSetFilter>
      <TextFieldStyle
        type="date"
        name={name}
        value={date[name]}
        placeholder="dd-mm-yyyy"
        onChange={valueChanged}
      />
    </ContainerModalSetFilter>
  )
}

export default ModalFilterDateSearch

ModalFilterDateSearch.propTypes = {
  onModelChange: PropTypes.func,
  name: PropTypes.string
}
